module.exports = __webpack_public_path__ + "img/zm.zm7d7825c.svg";